import styled, { CSSObject } from 'styled-components';

interface AvatarProps {
  size?: string;
  selected?: boolean;
  bg?: string;
}

const AvatarStyled = styled.div<AvatarProps>(
  ({ theme, size, selected, bg }) => {
    const styleSheet: CSSObject = {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 100,
      border: `1px solid ${theme.color.wfWhite}`,
      boxSizing: 'border-box',
      backgroundColor: bg,
    };

    if (size === 'small') {
      styleSheet.width = 18;
      styleSheet.height = 18;
    }

    if (size === 'normal') {
      styleSheet.width = 24;
      styleSheet.height = 24;
    }

    if (size === 'medium') {
      styleSheet.width = 32;
      styleSheet.height = 32;
    }

    if (size === 'large') {
      styleSheet.width = 56;
      styleSheet.height = 56;
    }

    if (selected) {
      styleSheet.border = `1px solid ${theme.color.wfBlue}`;
    }

    return styleSheet;
  },
);

const AvatarImgStyled = styled.img<AvatarProps>(() => ({
  display: 'block',
  borderRadius: 100,
}));

const AvatarNameStyled = styled.span<AvatarProps>(({ theme, size }) => {
  const styleSheet: CSSObject = {
    textAlign: 'center',
    color: `${theme.color.wfWhite}`,
    fontSize: `${theme.font.size.default}`,
  };

  if (size === 'small') {
    styleSheet.fontSize = `${theme.font.size.small}`;
  }
  if (size === 'normal') {
    styleSheet.fontSize = `${theme.font.size.default}`;
  }
  if (size === 'medium') {
    styleSheet.fontSize = `${theme.font.size.medium}`;
  }
  if (size === 'large') {
    styleSheet.fontSize = `${theme.font.size.large}`;
  }

  return styleSheet;
});

export { AvatarStyled, AvatarImgStyled, AvatarNameStyled };
